export default __webpack_public_path__ + "static/media/hosting_lobby_mockup.b7ac6972.png";